import React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material';
import { colorPalette } from '../../colorPalette';
const BorderLinearProgress = styled(LinearProgress)(({ barWidth = '100px', barHeight = '6px', barEmptyColor = colorPalette.gray200, barFilledColor = colorPalette.yellow500, }) => ({
    height: barHeight,
    width: barWidth,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: barEmptyColor,
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: barFilledColor,
    },
}));
export const RatingBar = ({ label, numberOfRating, totalRating, barEmptyColor, barFilledColor, barHeight, barWidth, labelStyle, numberofRatingStyle, }) => {
    return (React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1, "data-qa": "ratingBar-core" },
        React.createElement(Typography, { "data-qa": "ratingBar-label", sx: Object.assign({ fontSize: '12px', textDecoration: 'underline' }, labelStyle) }, label),
        React.createElement(Box, null,
            React.createElement(BorderLinearProgress, { variant: "determinate", value: (numberOfRating / totalRating) * 100, barEmptyColor: barEmptyColor, barFilledColor: barFilledColor, barHeight: barHeight, barWidth: barWidth })),
        React.createElement(Typography, { "data-qa": "ratingBar-rating-number", sx: Object.assign({ fontSize: '12px' }, numberofRatingStyle) }, numberOfRating)));
};
